<template>
    <div class="wrapper__inner">
        <div class="container">
            <div class="price">
                <div class="price__top">
                    <div class="content-left">
                        <ButtonGrayButton
                            @click="jumpToPage"
                        >
                            <IconSvgUse
                                size="18px"
                                use="icon-arrow-left-small"
                                class="inline-block"
                            />
                            {{ $t('waves.Back') }}&nbsp;
                        </ButtonGrayButton>
                        <h1 class="title">
                            {{ $t('waves.PriceFormulationTitle' )}}
                        </h1>
                        <p>
                            {{ $t('waves.ToEnsureTransparent')}}
                        </p>
                        <p>
                            {{ $t('waves.ThisApproachEnables')}}
                        </p>
                    </div>
                    <div class="content-right">
                        <img class="top__bg-l"
                            src="./img/formulation-pic.png" 
                            alt="bg"
                        />
                    </div>
                </div>
                <div class="price__bottom">
                    <div class="steps">
                        <h5 class="my-h5">
                            {{ $t('waves.TheCalculationSteps') }}
                        </h5>
                        <ul>
                            <li>
                                {{ $t('waves.steps1') }}
                            </li>
                            <li>
                                {{ $t('waves.steps2') }}
                            </li>
                            <li>
                                {{ $t('waves.steps3') }}
                            </li>
                            <li>
                                {{ $t('waves.steps4') }}
                            </li>
                            <li>
                                {{ $t('waves.steps5') }}
                            </li>
                            <li>
                                {{ $t('waves.steps6_1') }}
                                <br />
                                <span>
                                    <!-- {{ $t('waves.steps6_2') }} -->
                                    P_buy(s) = max{ґp_i | sum_{i in 1..N}{s_i} &lt;= s}
                                </span>
                                <br />
                                {{ $t('waves.steps6_3') }} 
                                <span>
                                    {{ $t('waves.steps6_4') }}
                                </span>
                                {{ $t('waves.steps6_5') }} 
                                <span>
                                    {{ $t('waves.steps6_6') }}
                                </span>
                                {{ $t('waves.steps6_7') }}
                            </li>
                            <li>
                                {{ $t('waves.steps7_1') }}
                                <br />
                                <span>
                                    {{ $t('waves.steps7_2') }}
                                </span>
                            </li>
                            <li>
                                {{ $t('waves.steps8_1') }}
                                <br />
                                <span>
                                    {{ $t('waves.steps8_2') }}
                                </span>
                            </li>
                        </ul>
                        <p>
                            {{ $t('waves.calculation_desc1_1') }}
                            <span>
                                {{ $t('waves.calculation_desc1_2') }}
                            </span>
                            {{ $t('waves.calculation_desc1_3') }}
                            <span>
                                {{ $t('waves.calculation_desc1_4') }}
                            </span>
                            {{ $t('waves.calculation_desc1_5') }}
                            <span>
                                {{ $t('waves.calculation_desc1_6') }}
                            </span>
                            {{ $t('waves.calculation_desc1_7') }}
                        </p>
                        <p>
                            {{ $t('waves.calculation_desc2') }}
                        </p>
                    </div>
                    <div class="liquidation">
                        <h3>
                            {{ $t('waves.liquidationTitle') }}
                        </h3>
                        <p>
                            {{ $t('waves.liquidation_desc1') }}
                        </p>
                        <p>
                            {{ $t('waves.liquidation_desc2_1') }}
                            <br />
                            <span>
                                {{ $t('waves.liquidation_desc2_2') }}
                            </span>
                            <br />
                            {{ $t('waves.liquidation_desc2_3') }} 
                        </p>
                    </div>
                    <div class="market">
                        <h3>
                            {{ $t('waves.MarketTitle') }} 
                        </h3>
                        <p></p>
                        <div>
                            {{ $t('waves.MarketTitle1') }} 
                        </div>
                        <div>
                            {{ $t('waves.MarketTitle2') }} 
                        </div>
                        <div>
                            {{ $t('waves.MarketTitle3') }} 
                        </div>
                        <br />
                        <p class="italic">
                            {{ $t('waves.MarketTitle_formula') }} 
                        </p>
                        <p>
                            {{ $t('waves.MarketTitle_last') }} 
                        </p>
                    </div>

                    <!-- ↓ 按钮 -->
                    <ButtonThe3DButton
                        color="red"
                        size="md"
                        class="mt-4"
                        @click="jumpToPage"
                    >
                        &emsp;{{ $t('waves.ToFutures') }}&emsp;
                    </ButtonThe3DButton>
                </div>
            </div>
        </div>
    </div>
</template>


<script lang="ts" setup>
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat';
import {oDefaultCoin} from '@/pages/casino/futuresGame/ts/wavesData';

toCloseLoading();

// ↓ 跳转到游戏页面 
const jumpToPage = ()=>{
    const sPath = `/casino/futuresGame/${oDefaultCoin.name}`;
    useNavigator(sPath);
}

</script>

<style src="./style/priceFormulation.scss" lang="scss" scoped></style>


